import { render, staticRenderFns } from "./GraphDetail14.vue?vue&type=template&id=385489e4&scoped=true"
import script from "./GraphDetail14.vue?vue&type=script&lang=js"
export * from "./GraphDetail14.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385489e4",
  null
  
)

export default component.exports